import { useEffect, useRef, useState } from "react";
import { userService } from "../../_services";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import EnterCodeModal from "../Model/EnterCodeModal";
import BackgroundDecorations from "../Common/BackgroundDecorations";
// import QrCodeModal from "../Model/QrCodeModel";

export default function Main() {
  const { t } = useTranslation();
  const [codeRes, setCodeRes] = useState();
  const [code, setCode] = useState("");
  const inputRef = useRef();
  const [showMainModal, setShowMainModal] = useState(false);
  const [qrModal, setQrModal] = useState(false);

  // Function to hide the main modal
  const hideModalHandler = () => {
    setShowMainModal(false);
    setCode("");
  };

  useEffect(() => {
    const handleKeyDown = (e) => numericKeyBtnHandler(e); // Call numeric Key Btn Handler on keydown
    window.addEventListener("keydown", handleKeyDown); // Add event listener for keydown
    return () => {
      window.removeEventListener("keydown", handleKeyDown); // Cleanup: remove event listener
    };
  }, []);
  // Function to handle code submission
  const submitCodeHandler = async () => {
    try {
      const res = await userService.getRequestByCode(code);
      // Check if the code entered is more than 4 or not
      if (code.length > 4) {
        toast("The code should not be more than 4 digits");
        return; // Exit the function early
      }
      // Handle API response errors
      if (res.status === "NOT_FOUND" || res.length === 0) {
        toast("Invalid code");
        return;
      }
      if (res.error === "invalid_token") {
        toast("Invalid code");
        return;
      }
      if (res.error === "unauthorized") {
        toast("It seems the account disconnected. Please login again.");
        return;
      }
      setCodeRes(res);
      setShowMainModal(true);
      setCode("");
    } catch (error) {
      // Handle unexpected errors
      console.error("Error in submitCodeHandler:", error);
      toast(
        "An error occurred while processing your request. Please try again."
      );
    }
  };
  // Function to handle numeric button clicks
  const numericBtnHandler = (e) => {
    try {
      const value = e.target.value;
      if (value == t("clear")) {
        setCode("");
      } else if (value == t("delete")) {
        setCode((prevState) => prevState.slice(0, -1)); // remove one digit
      } else {
        setCode((prevState) => prevState + value);
      }
    } catch (error) {
      // Handle unexpected errors
      console.error("Error in numericBtnHandler:", error);
      toast("An error occurred while processing your input. Please try again.");
    }
  };
  // Function to handle numeric key presses on the keyboard
  const numericKeyBtnHandler = (e) => {
    try {
      if (e.key >= "0" && e.key <= "9") {
        setCode((prevState) => prevState + e.key);
      } else if (e.key === "Backspace") {
        setCode((prevState) => prevState.slice(0, -1));
      }
    } catch (error) {
      // Handle unexpected errors
      console.error("Error in numericKeyBtnHandler:", error);
      toast("An error occurred while processing your input. Please try again.");
    }
  };
  // Function to handle QR code scanning
  const qrCodeHandler = (scannedCode) => {
    const fetch = async () => {
      try {
        // Call the API to validate the scanned code
        const res = await userService.getRequestByCode(scannedCode);

        // Handle API response errors
        if (res.status === "NOT_FOUND" || res.length === 0) {
          toast("Invalid code");
          return;
        }
        if (res.error === "invalid_token") {
          toast("Invalid code");
          return;
        }
        if (res.error === "unauthorized") {
          toast("It seems your account disconnected. Please login again.");
          return;
        }
        // If the code is valid, update state and show the main modal
        setCodeRes(res); // Store the API response
        setShowMainModal(true);
        setQrModal(false);
        setCode(""); // Clear the code input after successful QR scan
      } catch (error) {
        // Handle unexpected errors
        console.error("Error in qrCodeHandler:", error);
        toast("An error occurred while processing the QR code. Please try again.");
      }
    };
    fetch(); // Call the fetch function
  };
  return (
    <div className="relative min-h-screen">
      {showMainModal && (
        <EnterCodeModal codeRes={codeRes} hideModalHandler={hideModalHandler} />
      )}
      <BackgroundDecorations />
      <div className="flex justify-center items-center min-h-screen relative z-10">
        <div className="w-full max-w-2xl bg-white rounded-[2.5rem] shadow-xl p-8 flex flex-col items-center">
          <h2 className="text-3xl font-semibold text-gray-800 mb-6">
            {t("home")}
          </h2>
          <input
            ref={inputRef}
            type="text"
            value={code}
            onClick={(e) => e.stopPropagation()}
            className="w-full h-[60px] text-center text-2xl bg-gray-100 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder={t("insertCode")}
            readOnly
          />
          <div className="grid grid-cols-3 gap-3 mt-6 mb-8 w-full">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((btnValue) => (
              <button
                key={btnValue}
                value={btnValue}
                onClick={numericBtnHandler}
                className="h-[60px] text-2xl border border-gray-300 rounded-lg shadow-sm bg-teal-500 text-white hover:bg-teal-600 transition-colors duration-200"
              >
                {btnValue}
              </button>
            ))}
            <button
              value={t("clear")}
              onClick={numericBtnHandler}
              className="h-[60px] text-2xl border border-gray-300 rounded-lg shadow-sm bg-red-500 text-white hover:bg-red-600 transition-colors duration-200"
            >
              {t("clear")}
            </button>
            <button
              value="0"
              onClick={numericBtnHandler}
              className="h-[60px] text-2xl border border-gray-300 rounded-lg shadow-sm bg-teal-500 text-white hover:bg-teal-600 transition-colors duration-200"
            >
              0
            </button>
            <button
              value={t("delete")}
              onClick={numericBtnHandler}
              className="h-[60px] text-2xl border border-gray-300 rounded-lg shadow-sm bg-red-500 text-white hover:bg-red-600 transition-colors duration-200"
            >
              {t("delete")}
            </button>
          </div>
          <button
            value={t("submit")}
            onClick={submitCodeHandler}
            className="w-full h-[50px] bg-yellow-500 text-white rounded-full text-lg font-semibold hover:bg-yellow-600 transition-all"
          >
            {t("submit")}
          </button>
        </div>
      </div>
    </div>
  );


}
{/*Instruction: adding the old code as a comment  */
  /* Uncomment if QR Code Modal is needed */
}
{
  /* {qrModal && (
        <QrCodeModal
          qrCodeHandler={qrCodeHandler}
          hideModalHandler={() => setQrModal(false)}
        />
      )} */
}
//   -  const qrCodeHandler = (scannedCode) => {
//   -    const fetch = async () => {
//   -      const res = await userService.getRequestByCode(scannedCode);
//   -      console.log(res);
//   -      if (res.status === "NOT_FOUND" || res.length === 0) {
//   -        toast("Invalid code");
//   -        return;
//   -      }
//   -      if (res.error === "invalid_token") {
//   -        toast("Invalid code");
//   -        return;
//   -      }
//   -      if (res.error === "unauthorized") {
//   -        toast("It seems your account disconnect. Please login to it again.");
//   -        return;
//   -      }
//   -      setCodeRes(res);
//   -      setShowMainModal(true);
//   -      setQrModal(false);
//   -      // setTodayHistory(await userService.getRequestByCode(code));
//   -    };
//   -    fetch();
//   -  };
